var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcessingState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4304 32.5714C8.00964 32.5714 2.95469 37.6682 3.46382 43.6288L6.41759 78.0046C6.87419 83.3265 11.6463 87.4286 17.3841 87.4286H102.615C108.349 87.4286 113.121 83.3265 113.582 78.0046L116.535 43.6288C117.049 37.6723 111.99 32.5714 105.569 32.5714H14.4304Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0462 93.4286L19.0362 46.1526C18.7062 45.2355 18.8391 44.1899 19.3791 43.4142C19.8205 42.7886 20.472 42.4286 21.1705 42.4286H40.5034C41.412 42.4286 42.2777 42.8228 42.9462 43.5428L46.2162 47.0782H69.8862C71.3477 47.0782 72.6505 48.0938 73.1991 49.6623L88.2762 92.6315C88.3405 92.8158 88.3148 93.0129 88.1991 93.1757C88.0877 93.3343 87.9077 93.4286 87.7148 93.4286H36.0462Z",
    fill: "#C2C2C2",
    stroke: "#999999",
    strokeWidth: 0.857143
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0763 93.4286L27.6892 49.5037C27.6506 49.3237 27.6892 49.1437 27.7963 49.0152C27.8734 48.9166 27.9806 48.8652 28.092 48.8652H80.0777L88.4649 92.7172C88.4992 92.8929 88.452 93.0729 88.3406 93.21C88.2292 93.3471 88.0577 93.4243 87.882 93.4243L36.0806 92.9957L36.0763 93.4286Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 0.857143
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1163 45.7755C35.1078 45.6083 35.1635 45.4583 35.2621 45.3512C35.3392 45.2698 35.4335 45.2269 35.5321 45.2269H87.2263C87.4492 45.2269 87.6292 45.4369 87.6421 45.7069L88.6363 89.6746L36.1021 92.9786L35.1121 45.7669L35.1163 45.7755Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 0.857143
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5292 48.2866C43.6106 47.6781 44.0477 47.2367 44.5663 47.2367L97.5849 47.001C97.6877 47.001 97.7906 47.0482 97.8677 47.1382C97.9706 47.2539 98.0177 47.4253 97.9963 47.5924L89.3563 89.6446L36.1492 92.9829L43.5249 48.2866H43.5292Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 0.857143
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4277 93.4285L48.2692 53.819C48.7534 52.1092 50.1206 50.9607 51.672 50.9607H98.3992C99.072 50.9607 99.6892 51.2821 100.135 51.8735C100.683 52.5977 100.855 53.5705 100.598 54.4833L89.0049 92.4301C88.8249 93.0257 88.2806 93.4285 87.6592 93.4285H36.4277Z",
    fill: "#EBEBEB",
    stroke: "#999999",
    strokeWidth: 0.857143
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8762 87.3691H69.1233C68.6348 87.3691 68.3733 86.9748 68.5405 86.4863L71.8576 76.7243C72.0248 76.2357 72.5519 75.8415 73.0405 75.8415H89.7933C90.2819 75.8415 90.5433 76.2357 90.3762 76.7243L87.0591 86.4863C86.8919 86.9748 86.3648 87.3691 85.8762 87.3691Z",
    fill: "#C2C2C2"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0187 57.4285C91.1349 57.4285 97.7144 50.849 97.7144 42.7328C97.7144 34.6166 91.1349 28.0371 83.0187 28.0371C74.9025 28.0371 68.323 34.6166 68.323 42.7328C68.323 50.849 74.9025 57.4285 83.0187 57.4285Z",
    fill: "#7A7A7A"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5529 55.9628C89.6691 55.9628 96.2486 49.3833 96.2486 41.2671C96.2486 33.1509 89.6691 26.5714 81.5529 26.5714C73.4367 26.5714 66.8572 33.1509 66.8572 41.2671C66.8572 49.3833 73.4367 55.9628 81.5529 55.9628Z",
    fill: "#7A7A7A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5528 45.6086C80.7342 45.6086 80.07 44.9443 80.07 44.1257V41.6786C80.07 40.86 80.7342 40.1957 81.5528 40.1957C82.7614 40.1957 83.7471 39.2143 83.7471 38.0014C83.7471 36.7886 82.7657 35.8071 81.5528 35.8071C80.34 35.8071 79.3585 36.7886 79.3585 38.0014C79.3585 38.82 78.6943 39.4843 77.8757 39.4843C77.0571 39.4843 76.3928 38.82 76.3928 38.0014C76.3928 35.16 78.7071 32.8457 81.5485 32.8457C84.39 32.8457 86.7043 35.16 86.7043 38.0014C86.7043 40.2857 85.2043 42.2871 83.0314 42.9386V44.1214C83.0314 44.94 82.3671 45.6043 81.5485 45.6043L81.5528 45.6086Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5529 49.5857C80.7344 49.5857 80.0701 48.9214 80.0701 48.1029C80.0701 47.2843 80.7344 46.62 81.5529 46.62C82.3715 46.62 83.0358 47.2843 83.0358 48.1029C83.0358 48.9214 82.3715 49.5857 81.5529 49.5857Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessingState);
export default __webpack_public_path__ + "static/media/processing-state.b4552a9ff23ac12187fbdb87a37e1f4c.svg";
export { ForwardRef as ReactComponent };